;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import React from "react"
import Menu from "../Menu"
import MenuItem from "../MenuItem"
import {
  TOP_NAV_MENU_TYPE_BECOME_GROUP_LEADER,
  TOP_NAV_MENU_TYPE_FIND_A_GROUP,
  TOP_NAV_MENU_TYPE_NEWSLETTER_SIGN_UP,
  TOP_NAV_MENU_TYPE_SIGN_UP_LOGIN,
} from "../constants"

export default function MenuMobileNotLoggedIn({
  trigger,
}: {
  trigger: React.ReactElement
}) {
  return (
    <Menu trigger={trigger}>
      <MenuItem topNavMenuItemType={TOP_NAV_MENU_TYPE_SIGN_UP_LOGIN} />
      <MenuItem topNavMenuItemType={TOP_NAV_MENU_TYPE_FIND_A_GROUP} />
      <MenuItem topNavMenuItemType={TOP_NAV_MENU_TYPE_BECOME_GROUP_LEADER} />
      <MenuItem topNavMenuItemType={TOP_NAV_MENU_TYPE_NEWSLETTER_SIGN_UP} />
    </Menu>
  )
}
